import axios from 'axios'
import { DateTime } from 'luxon'
import React, { useEffect, useMemo, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import './_viewYear.scss'
import { setData, setFasce, setKwhAvg, setKwhMax, setSpesaAvg, setSpesaMax } from '../../../features/dataYearSlice';
import BarContainer from './_barContainer'
import CircularProgress from '@mui/material/CircularProgress';
import BarIndex from './_barIndex'
import YearFilter from './_filter'
import Fasce from './_fasce'
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import ListYear from './_list'
import md5 from 'md5'
import CardYear from './_cardsYear'
import { ReactComponent as Euro } from "../../../assets/new-icons/euroIcon.svg";


function ViewYear() {
    const dispatch = useDispatch()
    const [year, setYear] = useState(DateTime.now().toFormat('y'))
    const [yearPrevious, setYearPrevious] = useState(DateTime.now().plus({ year: -1 }).toFormat('y'))
    const [lastYear, setLastYear] = useState(DateTime.now().toFormat('y'))
    const [loading, setLoading] = useState(true)
    const podCode = useSelector((user) => user.user.info.pod_code)
    const token = useSelector((user) => user.user.info.token_value)
    const customerId = useSelector((user) => user.user.info.customer_id);
    const tkn = md5(customerId + 'oYmAIdtki%lu')
    const userToken = useSelector((user) => user.user.info.user_id)
    const data = useSelector((user) => user.dataYear.data)
    const maxValueArray = data && data.map((r) => parseFloat(r.entry_kwh))
    const maxEuroArray = data && data.map((r) => parseFloat(r.entry_amount))
    const maxValue = maxValueArray && Math.max(...maxValueArray)
    const maxEuro = maxEuroArray && Math.max(...maxEuroArray)
    const maxEuroValue = maxEuroArray && Math.max(...maxEuroArray)
    const maxKwhValue = maxValueArray && Math.max(...maxValueArray)
    const [maxItems, setMaxItems] = useState(6)
    const getSumValue = maxValueArray && maxValueArray.reduce((a, b) => a + b, 0)
    const avarageKwh = maxValueArray && (getSumValue / maxValueArray.length) || 0
    const [switchEuro, setSwitchEuro] = useState(true)

    useEffect(() => {
        init()
    }, [])


    const init = async () => {
        if (!customerId || !podCode || !token || !userToken || !tkn) {
            setLoading(true)
            return;
        } else {
            const api = `https://my.revoluce.it/area_utente/gestione/api/deliveries/getDeliveryRevo.php?customer_id=${customerId}&user_id=${userToken}&token=${token}&pod_code=${podCode}&tkn_pvt=${tkn}`
            const res = await axios.get(api)
            if (res.status !== 200) return
            const { data: dataYear } = res
            const { data, fasce_anno_corrente: { total_f1, total_f2, total_f3 }, max_euro, max_kwh } = dataYear
            const f1 = total_f1.toFixed(2)
            const f2 = total_f2.toFixed(2)
            const f3 = total_f3.toFixed(2)
            dispatch(setData(data.reverse()))
            dispatch(setFasce([f1, f2, f3]))
            dispatch(setKwhMax(max_kwh))
            setLoading(false)
        }
    }

    const goBack = () => {
        setLoading(true)
        setTimeout(() => {
            setLoading(false)
        }, 1000)
        setYear(DateTime.fromFormat(year, 'y').plus({ year: -1 }).toFormat('y'))
        setYearPrevious(DateTime.fromFormat(yearPrevious, 'y').plus({ year: -1 }).toFormat('y'))
        setMaxItems(6)
    }
    const goForward = () => {
        setLoading(true)
        setTimeout(() => {
            setLoading(false)
        }, 1000)
        setYear(DateTime.fromFormat(year, 'y').plus({ year: +1 }).toFormat('y'))
        setYearPrevious(DateTime.fromFormat(yearPrevious, 'y').plus({ year: +1 }).toFormat('y'))
        setMaxItems(6)
    }
    return (
        <div className='year'>
            <div className="year_graph" style={loading ? { alignItems: 'center', justifyContent: 'center' } : null}>
                {loading ? (
                    <div className="loader">
                        <CircularProgress />
                    </div>
                ) : (
                    <>
                        <div className="backgroundLine">
                            <div className="line"></div>
                            <div className="line"></div>
                            <div className="line"></div>
                        </div>
                        <BarIndex maxEuroValue={maxEuroValue} switchEuro={switchEuro} maxKwhValue={maxKwhValue} />
                        <div className="year_graph-wrapper">
                            {
                                data && data
                                .filter((r) => r.data_competenza.includes(year))
                                .map((d, i) => (
                                    <BarContainer key={i} data={d} switchEuro={switchEuro} maxEuro={maxEuro} maxValue={maxValue} avarageKwh={avarageKwh}/>
                                ))
                            }
                        </div>
                    </>
                )}
            </div>
            <div className="year-filter_switch">
                <div className="year-filter_switch-right">
                    <YearFilter yearPrevious={yearPrevious} data={data} goForward={() => goForward()} goBack={() => goBack()} year={year} lastYear={lastYear} />
                </div>
                <div className="year-filter_switch-left">
                    <div className="switch" onClick={() => setSwitchEuro(!switchEuro)}>
                        <div className={`box ${switchEuro ? 'active' : null}`}>
                            <Euro />
                        </div>
                        <div className={`box ${!switchEuro ? 'active' : null}`}>
                            <p>kWh</p>
                        </div>
                    </div>
                </div>
            </div>
            <div className="year_cards">
                {data && data
                .filter((r) => r.data_competenza.includes(year))
                .map((d, i) => (
                     
                        <CardYear  key={i} data={d} />
                    
                ))}
            </div>
            <Fasce />
            <ListYear maxItems={maxItems} setMaxItems={setMaxItems} data={data} goForward={() => goForward()} goBack={() => goBack()} year={year} yearPrevious={yearPrevious}/>
             
        </div>
    )
}

export default ViewYear